<template>
  <div class="main">
    <div class="header">
      <div> <a href="/"><img :src="require('@/assets/image/h5/logo-large.png')" alt=""></a> </div>
      <div>
        <a href="/">登录</a> | 客服电话：4006-135-135
      </div>
    </div>
    <div class="step-box">
      <div class="step-box-title"><span class="title-name">供应商入驻须知</span><a href="/#/supplierPoolInfo"><span class="title-btn">成为供应商</span></a></div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="item-title"><img :src="require('@/assets/image/h5/step/1.png')" alt=""> 填报意向合作基础信息</div>
          <div>
            <p>完善意向合作基本信息(主要包括基础信息和经营品类信息）意向合作基础信息包括：基本信息和经营品类信息；</p>
            <p>请认真填写并确保信息准确，便于我司对应品类采购人员快速确认和您联系。</p>
          </div>
          <div class="item-time"><img :src="require('@/assets/image/h5/icon_time.png')" alt="">约3分钟</div>
        </el-col>
        <el-col :span="12">
          <div class="item-title"><img :src="require('@/assets/image/h5/step/2.png')" alt=""> 待采购人员认领确认信息</div>
          <div>
            <p>提交意向合作信息后，待美菜采购人员与您联系；</p>
            <p>如您收到短信信息提示：您的意向合作申报信息已由**品类采购人员认领，于2个工作日内将会处理回复，请耐心等待。</p>
          </div>
          <div class="item-time"><img :src="require('@/assets/image/h5/icon_time.png')" alt="">约2个工作日</div>
        </el-col>
      </el-row>
     <el-row :gutter="20">
       <el-col :span="12">
          <div class="item-title"><img :src="require('@/assets/image/h5/step/3.png')" alt=""> 下载美菜供应商APP</div>
          <div>
            <p>如我司对应品类采购人员已与您联系并洽谈合作，即可下载美菜APP注册；</p>
            <p>下载美菜供应商APP；</p>
            <p>下载成功，进入手机账号注册（已注册手机号不能再注册）。</p>
          </div>
          <div class="item-time"><img :src="require('@/assets/image/h5/icon_time.png')" alt="">约3分钟</div>
        </el-col>
        <el-col :span="12">
          <div class="item-title"><img :src="require('@/assets/image/h5/step/4.png')" alt=""> 登录美菜APP，自主申报资质建档信息</div>
          <div>
            <p>使用注册手机号登录APP，按照信息提示（报名入驻）/在采购人员指导下完成资质建档信息自主申报；</p>
            <p>信息填报完整且检查无问题，提交即可。</p>
          </div>
          <div class="item-time"><img :src="require('@/assets/image/h5/icon_time.png')" alt="">约10分钟</div>
        </el-col>
    </el-row>
       <el-row :gutter="20">
       <el-col :span="12">
          <div class="item-title"><img :src="require('@/assets/image/h5/step/3.png')" alt=""> 资质审核</div>
          <div>
            <p>提交后的信息待美菜内部审核；审核通过会以短信提示；</p>
            <p>资质审核未通过，将驳回并提示重新修正后再提报。</p>
          </div>
          <div class="item-time"><img :src="require('@/assets/image/h5/icon_time.png')" alt="">约2小时</div>
        </el-col>
        <el-col :span="12">
          <div class="item-title"><img :src="require('@/assets/image/h5/step/4.png')" alt=""> 合同签署&合同审批</div>
          <div>
            <p>资质审批通过，由采购人员线上发起电子合同签署流程；</p>
            <p>双方合同签署盖章完成，即入驻成功。</p>
          </div>
          <div class="item-time"><img :src="require('@/assets/image/h5/icon_time.png')" alt="">约4小时</div>
        </el-col>
    </el-row>
    <div class="entry-explain">
      <div class="entry-explain-content">
        <div class="title"><span></span> 入驻说明</div>
        <p>1.提交合作资质符合法律法规及甲方要求的相关证明文件，并保证其真实、合法、准确、有效。</p>
        <p>2.供应商申报意向合作信息后，会有采购团队跟进对接</p>
        <p>3.美菜供应商APP及微信公众号</p>
        <p>扫描下方二维码下载安装（ios版请前往Appstore，搜索“美菜供应商”下载）</p>
        <p>美菜公众号：关注美菜（可扫下方二维码)--合作共赢--成为供应商</p>
        <p>联系客服：4006-135-135</p>
        <div class="qr-code">
          <div>
            <img src="@/assets/image/h5/app.png" alt="">
            <p>美菜供应商APP安卓版</p>
          </div>
          <div>
            <img src="@/assets/image/h5/wechat.png" alt="">
            <p>美菜微信公众号</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="bottom">
      <p>copyright©2014-2020 北京云杉世界信息技术有限公司 4006-135-135</p>
      <p>北京市朝阳区安贞路安贞西里5区1号楼新华金融大厦3-4层 京ICP备14045665号-2</p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  font-family: "Helvetica Neue,Helvetica,Arial,sans-serif";
  .header {
    padding: 26px 60px;
    width: 100%;
    height: 200px;
    border-bottom: 2px solid #3ACB6C;
    box-shadow: 1px 1px #E2E2E2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 100px;
      height: 44px;
    }
    a {
      text-decoration: none;
      color: #3ACB6C
    }
  }
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
  .step-box {
  .step-box-title {
      margin: 20px;
      display: flex;
      justify-content: center;
      border-radius: 2px;
      .title-name {
        font-size: 24px;
        font-weight: 500;
      }
      .title-btn {
        margin-left: 20px;
        display: inline-block;
        width: 130px;
        background: #4BCB81;
        height: 34px;
        line-height: 34px;
        color:#FFF;
        font-size: 14px;
        text-align: center;
      }
    }
    .el-row {
    justify-content: space-between;
    max-width: 960px;
    margin-bottom: 30px;
    .el-col {
      font-size: 12px;
      padding: 20px;
      max-width: 440px;
      border: 1px solid #ddd;
      margin-right: 30px;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        line-height: 26px;
        text-indent:2em
      }
      .item-title {
        font-size: 16px;
        font-weight: 600;
        height: 30px;
        line-height: 30px;
      }
      .item-time {
        color: #F0547C;
        font-weight: 700;
        font-size: 16px;
        margin-top: 10px;
        img {
          margin-right: 10px;
          vertical-align: middle;
          height: 24px;
          width: 26px;
        }
      }
    }
  }
  .entry-explain {
    margin: 0 10px 20px -10px;
    .entry-explain-content {
    color: #5A5A5A;
    font-size:12px;
    background: #F8F8F8;
    padding: 16px 11px 24px 12px;
    p {
      height: 24px;
      line-height: 24px;
    }
    .title {
      color: #333333;
      font-weight: 500;
      font-size:14px;
      span {
        display: inline-block;
        width:3px;
        height:13px;
        background: #3DBC73;
        border-radius:2px;
      }
    }
    .qr-code {
      display: flex;
      justify-content: flex-start;
      img {
        width: 140px;
        height: 140px;
      }
      p {
        text-align: center;
      }
    }
    }
  }
  }
  .bottom {
    width: 100%;
    padding: 20px;
    background: #E8E9E8;
    text-align: center;
    font-size: 12px;
    color:#A2A2A2;
    p {
      height: 30px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/supplierPool/pc/guide.vue